module.exports = __webpack_public_path__ + "assets/img/script_template.8efd7ea6.jpg";